(() => {
  const initSubscriptionFeature = (root = document) => {
    root.querySelectorAll('[data-zero-subscription-feature]').forEach((section) => {
      if (section.dataset.subscriptionFeatureInitialized === 'true') return;
      section.dataset.subscriptionFeatureInitialized = 'true';

      const form = section.querySelector('[data-subscription-form]');
      const title = section.querySelector('[data-subscription-title]');
      const meta = section.querySelector('[data-subscription-meta]');
      const media = section.querySelector('.zero-subscription-feature__media');
      const currentPrice = section.querySelector('[data-subscription-current-price]');
      const originalPrice = section.querySelector('[data-subscription-original-price]');
      const flavorSelect = section.querySelector('[data-subscription-flavor-select]');

      if (!form) return;

      const variantInput = form.querySelector('[data-subscription-variant]');
      const planSelect = form.querySelector('[data-subscription-plan]');
      const button = form.querySelector('[data-subscription-button]');
      const buttonLabel = form.querySelector('[data-subscription-button-label]');
      const flavorIcon = section.querySelector('[data-subscription-flavor-icon]');
      const defaultFrequency = section.dataset.defaultFrequency || '30';
      const productsById = new Map();

      const renderTitle = (element, value) => {
        element.replaceChildren();
        String(value || '').split('®').forEach((part, index, parts) => {
          if (part) element.appendChild(document.createTextNode(part));
          if (index < parts.length - 1) {
            const registered = document.createElement('sup');
            registered.className = 'zero-subscription-feature__registered';
            registered.textContent = '®';
            element.appendChild(registered);
          }
        });
      };

      const formatPlanLabel = (plan) => {
        if (plan.label) return plan.label;
        const match = String(plan.name || '').match(/\b(14|30|60)\b/);
        return match ? match[1] + ' days' : plan.name;
      };

      const replaceFeatureImage = (data) => {
        if (!media || !data.image) return;

        const currentImage = media.querySelector('.zero-subscription-feature__image');
        const nextImage = currentImage
          ? currentImage.cloneNode(false)
          : document.createElement('img');

        [
          'src',
          'srcset',
          'sizes',
          'loading',
          'fetchpriority',
          'width',
          'height',
          'data-src',
          'data-srcset',
          'data-lazy-src',
          'data-original'
        ].forEach((attribute) => nextImage.removeAttribute(attribute));

        nextImage.className = 'zero-subscription-feature__image';
        nextImage.alt = data.imageAlt || data.title || '';
        nextImage.decoding = 'async';
        nextImage.loading = 'eager';
        nextImage.src = data.image;

        if (currentImage) {
          currentImage.replaceWith(nextImage);
        } else {
          media.appendChild(nextImage);
        }
      };

      const updatePrice = (data, selectedPlan) => {
        if (currentPrice) currentPrice.textContent = selectedPlan.price || '';
        if (originalPrice) {
          originalPrice.textContent = data.originalPrice || '';
          originalPrice.hidden = !data.originalPrice;
        }
      };

      section.querySelectorAll('[data-subscription-flavor-data]').forEach((dataElement) => {
        try {
          productsById.set(dataElement.dataset.subscriptionProductId, JSON.parse(dataElement.textContent));
        } catch (error) {
          // A malformed optional flavor entry should not interrupt the purchase form.
        }
      });

      const choosePlan = (plans) =>
        plans.find((plan) => String(plan.name).includes(defaultFrequency)) || plans[0];

      const updateFeature = (data) => {
        if (!data) return;

        if (title) renderTitle(title, data.title);
        if (meta) meta.textContent = data.meta || '';
        replaceFeatureImage(data);

        if (flavorIcon) {
          if (data.flavorIcon) {
            flavorIcon.src = data.flavorIcon;
            flavorIcon.removeAttribute('srcset');
            flavorIcon.hidden = false;
          } else {
            flavorIcon.hidden = true;
          }
        }

        variantInput.value = data.variantId;
        planSelect.innerHTML = '';

        if (!data.plans || !data.plans.length) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          if (buttonLabel) buttonLabel.textContent = 'SOLD OUT';
          return;
        }

        data.plans.forEach((plan) => {
          const option = document.createElement('option');
          option.value = plan.id;
          option.textContent = formatPlanLabel(plan);
          planSelect.appendChild(option);
        });

        const selectedPlan = choosePlan(data.plans);
        planSelect.value = selectedPlan.id;

        const setButtonLabel = () => {
          const selected = data.plans.find((plan) => plan.id === planSelect.value) || selectedPlan;
          updatePrice(data, selected);
          if (buttonLabel) buttonLabel.textContent = 'SUBSCRIBE & SAVE — ' + selected.price;
        };

        setButtonLabel();
        planSelect.onchange = setButtonLabel;

        button.disabled = !data.available;
        button.setAttribute('aria-disabled', String(!data.available));
        if (!data.available && buttonLabel) buttonLabel.textContent = 'SOLD OUT';
      };

      const initialData = flavorSelect ? productsById.get(flavorSelect.value) : null;
      if (initialData) {
        updateFeature(initialData);
      }

      if (flavorSelect) {
        flavorSelect.addEventListener('change', () => {
          updateFeature(productsById.get(flavorSelect.value));
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSubscriptionFeature());
  } else {
    initSubscriptionFeature();
  }

  document.addEventListener('shopify:section:load', (event) => initSubscriptionFeature(event.target));
})();